<template>
	<div class="nutrition">
		<Breadcrumbs :items="items" />
		<v-container fluid>
			<v-row no-gutters>
				<v-col cols="12">
					<v-card flat>
						<v-card-text v-if="customTest">
							<CustomTestSettingsForm ref="testForm" :customTest="customTest" :variables="variables" />
						</v-card-text>
						<v-card-actions>
							<v-btn color="primary" text :to="{ name: 'settings', params: { tab: 'tests' } }">
								<translate>Back</translate>
							</v-btn>
							<v-btn color="primary" @click="showDeleteAlert = true" :loading="loading">
								<v-icon>delete</v-icon>
								<translate>Delete</translate>
								<DeleteConfirmationDialog
									v-model="showDeleteAlert"
									item="test"
									@delete="removeTest"
								/>
							</v-btn>
							<v-spacer></v-spacer>
							<v-btn color="secondary" class="primary--text" depressed  @click="editTest" :loading="loading">
								<translate>Save</translate>
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";
import axios from "axios";
import CustomTestSettingsForm from '../../components/appointment/tests/custom/CustomTestSettingsForm.vue';

export default {
	name: "CustomTest",
	components: {
		Breadcrumbs,
		DeleteConfirmationDialog,
		CustomTestSettingsForm
	},
	data: () => ({
		customTest: null,
		showDeleteAlert: false,
		loading: false,
		variables: []
	}),
	computed: {
		items() {
			let name = "";
			if (this.customTest) name = this.customTest.name;
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: { name: "home" },
				},
				{
					text: this.$gettext("Tests"),
					disabled: false,
					link: true,
					to: { name: "tests" },
				},
				{
					text: name,
					disabled: true,
					link: true,
				},
			];
		}
	},
	methods: {
		editTest() {
      if(this.$refs.testForm.validate()) {
        this.loading = true;
        axios
          .post("/custom-tests/" + this.customTest.id, this.customTest)
          .then(response => {
            console.log(response.data);
            if (response.data.result == "edited") {
							//this.customTest = response.data.test;
							this.$router.push({
								name: "settings",
								params: { tab: "tests" }
							})
            }
            this.loading = false;
          })
          .catch(error => {
            console.log(error);
            this.loading = false;
          });
      }
    },
    removeTest() {
      this.loading = true;
      axios
				.post("/custom-tests/" + this.customTest.id + "/delete")
				.then(response => {
					console.log(response.data);
					if (response.data.result == "deleted") {
            //this.tests.splice(this.tests.indexOf(test), 1);
						this.showDeleteAlert = false;
						this.$router.push({
							name: "settings",
							params: { tab: "tests" }
						})
          }
          this.loading = false;
				})
				.catch(error => {
          console.log(error);
          this.loading = false;
        });
		}
	},
	created() {
		const testId = this.$route.params.tid;
		axios
			.get("/custom-tests/" + testId)
			.then((response) => {
				console.log(response.data);
				this.customTest = response.data.test;
				this.variables = response.data.variables;
			})
			.catch((error) => console.log(error));
	},
};
</script>